import { DictionaryFormatter, DictionaryModel, UmbracoDictionaryItem } from './DictionaryTypes'

/** Formats retreived translations from Umbraco to dictionary items */
const formatUmbracoItemsToDictionary: DictionaryFormatter = (umbracoItems: UmbracoDictionaryItem[]) => {
    const dictionary: DictionaryModel = {}
    if (umbracoItems) {
        umbracoItems.forEach((item) => {
            if (item?.key) dictionary[item.key] = item.value || item.key
        })
    }
    return dictionary
}

export const DictionaryFormatters = {
    fromUmbraco: formatUmbracoItemsToDictionary,
}
